import React, { useState } from "react";
import { Admin } from "@iibf/shared-resources/models/db";
import usePromise from "./usePromise";
import { getCookieObject } from "../cookie";
import { services } from "../../services";
import { setAccessToken } from "../../services/request";
import { TokenPayload } from "@iibf/shared-resources/models/auth/index";

export type AuthState = { is_authenticated: boolean } & Partial<{
  access_token: string;
  admin: Pick<Admin, "id" | "stateId" | "email" | "name">;
}>;

export function useAuth() {
  const [authState, setAuthState] = useState<AuthState>({
    is_authenticated: false,
  });

  const { error } = usePromise(
    {
      fn: async () => {
        const { access_token: accessToken } = getCookieObject();
        const cookieValidationResponse = await services.requestSvc
          .post<{
            actor: {
              id: number;
              email: string;
              name: string;
              stateId: number;
            };
            tokenPayload: TokenPayload;
          }>(
            "/validate-token",
            {
              source: "admin",
            },
            {
              headers: { Authorization: "Bearer " + accessToken },
            }
          )
          .catch(console.error);

        console.log("Cookie validation response", cookieValidationResponse);

        if (cookieValidationResponse) {
          setAuthState({
            is_authenticated: true,
            access_token: accessToken,
            admin: {
              id: BigInt(cookieValidationResponse.actor.id),
              email: cookieValidationResponse.actor.email,
              stateId: cookieValidationResponse.actor.stateId
                ? BigInt(cookieValidationResponse.actor.stateId)
                : undefined,
              name: cookieValidationResponse.actor.name,
            },
          });

          if (
            cookieValidationResponse.actor.id.toString() !==
            localStorage.getItem("actorId")
          )
            localStorage.clear();

          localStorage.setItem(
            "actorId",
            cookieValidationResponse.actor.id.toString()
          );
          setAccessToken(accessToken);
        } else {
          setAuthState({
            is_authenticated: false,
            access_token: undefined,
            admin: undefined,
          });
          localStorage.clear();
          setAccessToken();
        }
      },
      runOnMount: { args: [] },
    },
    []
  );

  console.log(error);

  return authState;
}
